
<template>
	<div class="driver-material">
		<div class="driver-material-wrap">
			<div class="driver-material-wrap-left">
				<div class="query-setting-box">
					<div class="query-setting-box-left">
						<div class="order-query-form-box">
							<label for="start-date">车牌号/司机/手机：</label>
							<span class="order-query-form-input"><input type="text" v-model="orderForm.keyword"  name="start-date"></span>
						</div>
						<div class="order-query-form-box">
							<label for="start-date">司机状态：</label>
							<span class="order-query-form-input">
								<el-select v-model="orderForm.state" placeholder="请选择" class="stSetSelect">
									<el-option
									v-for="item in stateList"
									:key="item.value"
									:label="item.label"
									:value="item.value">
									</el-option>
								</el-select>
							</span>
						</div>
					</div>
					<div class="order-query-form-box-right">
						<span class="order-query-form-submit stPointer" @click="searchList()">查询</span>
					</div>
				</div>
				<div class="driver-search-box">
					<div class="st-pos-search-box">
						<div class="st-pos-input">
							<input type="text" placeholder="查询结果">
						</div>
						<span class="st-pos-btn stFbgc" @click="searchPos">获取位置</span>
					</div>
					<div class="data-table-box">
						<div class="data-table">
							<el-table :data="dataList" style="width: 100%" @selection-change="handleSelectionChange" height="300"   :show-header="false">
								<el-table-column  width="50" label="选择" class="data-icon-checked">
									<template slot-scope="scope">
					                    <el-radio :label="scope.row" v-model="selDriverId"  ><i> </i></el-radio>
					                </template>
								</el-table-column>
								<el-table-column prop="carNo" label="车牌号" width="142">
								</el-table-column>
								<el-table-column prop="name" label="姓名电话" width="200">
									<template slot-scope="scope">
										<span>（{{scope.row.name}}，{{scope.row.phone}}）</span>
									</template>
								</el-table-column>
								<el-table-column prop="stateDesc" label="状态" width="">
									<template slot-scope="scope">
										<span :class="scope.row.state">{{scope.row.stateDesc}}</span>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
					<div class="st-order-bottom clearfix">
						<div class="page-floote-box clearfix fl" v-show="togglePage">
							<div class="st-page-switch">
								<span class="st-page-prev":class="this.listPage.current<=1?'stDisabled':''"   @click="pagePrev"></span>
								<span class="st-page-current"><input type="text" v-model="listPage.current"></span>
								<span class="st-page-next" :class="listPage.current>=listPage.pages?'stDisabled':''" @click="pageNext"></span>
							</div>
							<el-select v-model="listPage.currentSize" placeholder="请选择" class="st-page-pagers" >
								<el-option
								v-for="item in listPage.sizes"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
							<div class="st-page-total">/共{{listPage.total}}条</div>
						</div>
					</div>
				</div>
			</div>
			<div class="driver-material-wrap-right stBgf">
				<div class="map" id="map">
					<baidu-map class="bm-view" center="广州" ak="YOUR_APP_KEY">
						<bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
  					</baidu-map>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
export default {
	name: 'DriverMaterial',
	props: [],
	components: {BaiduMap},
	data(){
		return{
			dataList:[], //司机列表
			orderForm:{
				keyword:null,
				state: 'LEISURE', // 状态 	LEISURE-空闲、PROCESS-已接单、PROCESSING-运输中
			},
			selDriverId:null,//选中的司机车牌号 获取位置用
			listPage:{
				currentSize:50,
				current: 1, //分页起始位置
				total: 0, // 总数量
				sizes: [{value:50,label:'每页50条'},{value:100,label:'每页100条'},{value:200,label:'每页200条'},{value:300,label:'每页300条'}], //分页大小
				page:1,
				pages:0,//总页数
			},
			togglePage:false, //是否显示分页
			selectedList:[],
			stateList:[{
					value:'LEISURE',
					label: '空闲'
				}, {
					value: 'PROCESS',
					label: '已接单'
				}, {
					value: 'PROCESSING',
					label: '运输中'
			}],
		}
	},
	created() {
		// console.log(BaiduMap)
	},
	methods: {
		searchList(){
			let pages={};
			pages.size=this.listPage.currentSize;
			pages.current=1;
			let orderForm=this.orderForm;
			Object.assign(orderForm,pages)
			this.$server.business.driverLocationPage(orderForm,(res)=>{
				if(res.code==0){
					this.dataList=res.data.records;
					this.listPage.total=res.data.total;
					this.listPage.current=res.data.current;
					this.listPage.pages=res.data.pages;
					console.log(res.data.current)
					if(res.data.total>0){
						this.togglePage=true;
					}
				}
			})
		},
		// 上一页
		pagePrev(){
			let pages={};
			pages.size=this.listPage.currentSize;
			if(this.listPage.current<=1){
				return ;
			}
			let orderForm=this.orderForm;
			pages.current=--this.listPage.current;
			Object.assign(orderForm,pages)
			this.$server.business.driverLocationPage(orderForm,(res)=>{
				if(res.code==0){
					this.dataList=res.data.records;
					this.listPage.total=res.data.total;
					this.listPage.current==res.data.current;
					this.listPage.pages=res.data.pages;
				}
			})
		},
		// 下一页
		pageNext(){
			let pages={};
			pages.size=this.listPage.currentSize;
			if(this.listPage.current>=this.listPage.pages){
				return ;
			}
			let orderForm=this.orderForm;
			pages.current=++this.listPage.current;
			Object.assign(orderForm,pages)
			this.$server.business.driverLocationPage(orderForm,(res)=>{
				if(res.code==0){
					this.dataList=res.data.records;
					this.listPage.total=res.data.total;
					this.listPage.current==res.data.current;
					this.listPage.pages=res.data.pages;
				}
			})
		},
		handleSelectionChange(val) {
			this.selectedList = val;
		},
		// 获取位置
		searchPos(){
			console.log(this.selDriverId)
		}
	},
	mounted() {
		
	}
}

</script>
<style scoped>
.driver-material {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
}
.driver-material-wrap{
	display: flex;
	justify-content: space-between;
}
.driver-material-wrap-left{
	width: 646px;
	display: flex;
	flex-direction: column;
}
.driver-material-wrap-right{
	width: 1150px;
	box-sizing: border-box;
	padding: 8px;
	overflow: hidden;
}
/* start */
.query-setting-box {
  height: auto;
  background: #FFF;
  padding: 18px 8px 0;
  position: relative;
  overflow: hidden;
  display: flex;
  font-size: 14px;
  margin-bottom: 8px;
}
.query-setting-box-left{
	flex: 1;
}
.order-query-form-box {
  float: left;
  width: 140px;
  height: auto;
  margin: 0 24px 18px 0;
}
.order-query-form-box-right{
	padding-top: 22px;
	width: 80px;
}
.order-query-form-box label {
  display: block;
  width: 100%;
  height: 22px;
  line-height: 22px;
  color: #383838;
}
.order-query-form-box input {
  display: block;
  width: 99%;
  height: 28px;
  line-height: 28px;
  border: 1px solid #DCDCDC;
  border-radius: 3px;
}

.order-query-form-submit {
  display: block;
  width: 80px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  color: #FFF;
  background: #FF5B3E;
  border: 1px solid #FF5B3E;
  border-radius: 3px;
  margin: 0 auto;
}
/* end */
/*  */
/* .data-table-box {
  height: auto;
  background: #FFF;
  padding: 8px ;
  overflow-y: auto;
  box-sizing: border-box;
} */

.data-table {
	margin-bottom: 8px;
}
.st-pos-search-box{
	display: flex;
	padding: 8px 0;
	border-bottom: 1px solid #D8D8D8;

}
.st-pos-input {
	flex: 1;
	
}
.st-pos-input input{
	height: 30px;
	border: none;
	outline: none;
}
.data-table-wrap{
	height: 642px;
	overflow-y: auto;
	padding: 8px;
}
.st-auto-table tr{
	height: 38px;
}
.st-auto-table tr td{
	height: 38px;
	line-height: 38px;
}
input.st-table-checkbox{
	width: 18px;
	height: 18px;
	/* background-color: #fff; */
}
input.st-table-checkbox[type=checkbox]:checked{
  	background: url('../../assets/images/icon_checked.png') center no-repeat;
	background-size:100% 100%;
	border: none;
}
/* stFbgc */
.st-pos-btn{
	display: inline-block;
	width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #fff;
    border-radius: 2px;
    cursor: pointer;
    margin-left: 8px;
}
.driver-search-box{
	flex-grow: 1;
	background:#fff;
	padding: 8px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	position: relative;
	overflow: hidden;
}
.data-table-box{
	padding: 0;
}
/* end */
.driver-search-wrap{
	flex-grow: 1;
}

.driver-search-form-items {
  float: left;
  width: auto;
  height: 100px;
  margin: 0 20px 0 0;
}

.driver-search-form-items label {
  display: block;
  width: 120px;
  height: 35px;
  line-height: 35px;
  position: relative;
  color: #383838;
}

.start-data-selector {
  width: 100px;
  background: #FF5B3E;
  color: #FFF !important;
  padding: 0 0 0 20px;
  position: relative;
}

.start-data-selector:after {
  display: block;
  /*width: 10px;*/
  /*height: 10px;*/
  content: "";
  /*background: #FFF;*/
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 8px solid #FFF;
  position: absolute;
  right: 10px;
  top: 15px;
}

.driver-search-form-items span {
  display: block;
  width: 180px;
  height: 33px;
  line-height: 33px;
  border: 1px solid #DCDCDC;
  border-radius: 4px;
}

.driver-search-form-items input {
  display: block;
  width: 168px;
  height: 33px;
  line-height: 33px;
  border: 1px solid #DCDCDC;
  border-radius: 4px;
  padding: 0 0 0 10px;
}

.driver-search-form-items .audit-checkbox {
  display: block;
  width: 30px;
  height: 30px;
}

.audit-checkbox-selected {
  background: url("../../assets/images/checkbox-selected.png") no-repeat 0 0;
  background-size: 100% 100%;
}

.audit-checkbox-unselected {
  background: url("../../assets/images/checkbox-selected.png") no-repeat 0 0;
  background-size: 100% 100%;
}

.driver-search-form-submit {
  display: block;
  width: 100px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  color: #FFF;
  background: #FF5B3E;
  border-radius: 4px;
  margin: 30px 0;
}

.driver-data-table-box {
  width: 98%;
  background: #FFF;
  padding: 10px;
}
.data-table .el-table .cell{
	color: #323232;
}
.PROCESS{
	color: #FF5B3E;
}
.LEISURE{
	color: #32BB57;
}
.PROCESSING{
color: #B5B5B5;
}
/* map */
.bm-view {
  width: 100%;
  height: 810px;
}
/* end */
@media only screen and (max-width: 1366px) {
	.driver-material-wrap-left{
		width: 448px;
	}
	.driver-material-wrap-right{
		width: 798px;
	}
	.bm-view {
		width: 100%;
		height: 624px; 
	}
}
</style>

